export default "__VITE_ASSET__D_m0KuGi__"